module.exports = __webpack_public_path__ + "static/media/yellowhead-5.e48aba9f.jpg";